<gt-phonenumber-adder [entries]="phonenumberEntries"
                      [orgId]="orgName"
                      [searchMainNumbers]="true"
                      [canEdit]="canEdit"
                      (addEntryChange)="addNameValueListEntry($event)"
                      (removeEntryChange)="removeNameValueListEntry($event)">
</gt-phonenumber-adder>
